import { BaseDto } from '@/shared/dtos/base-dto';

export class crm_oportunidades extends BaseDto {
    public client_id!: number;
    public titulo!: string;
    public valor_estimado!: number;
    public probabilidad_cierre!: number;
    public estado_pipeline!: string;
    public fecha_cierre_esperada!: Date | null;
    public origen_ia!: number;
    public razonamiento_ia!: string;
}
